import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IProductSuggestRequest } from '../models/ProductSuggestListModel'

export class UpdateProductSuggestApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productSuggest/updateProductSuggest',
      requesterInfo,
    })
  }

  public async updateProductSuggest(request: IProductSuggestRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
